<template>
  <div>
    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
        
                overlay="linear-gradient(to bottom, #003, transparent)" 
                :class="`thing playercss`"
                :style="`height: 556px;`" v-show="pvisvideo === true">
              </video-background>
            </Transition>
            <div id="panorama" class="thing  gradient" v-show="pvisvideo === false">
            </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext" :class="formatvhtml"></h1>
        </div>
      </main>
   
    </section>

<section>
  <div class="seven3css" >
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-9">
        <div class="formattoptext"><b>{{pyeardesc}} </b> <b>GOALS</b></div>
        <div class="accordion" id="accordionExample" style="background-color: grey;">
          <div class="accordion-item"  v-for="(cat, index) in getgoalperf" :key="cat.gcid">
            <h2 class="accordion-header" :id="`heading${cat.gcid}`">
              <button  @click="onClick(catid=cat.gcid)" class="accordion-button" :id="`accbtn${index%2}`" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${cat.gcid}`" aria-expanded="false" :aria-controls="`collapse${cat.gcid}`">
                {{cat.gcatdesc}}
              </button>
            </h2>
            <div :id="`collapse${cat.gcid}`" class="accordion-collapse collapse" :aria-labelledby="`heading${cat.gcid}`" data-bs-parent="#accordionExample">
              <div class="accordion-body" style="background-color: whitesmoke;">
                
                <table class="table" style="background-color: whitesmoke;">
                  <tr v-for="(goal, index) in allgoalslisting" :key="goal.gid">
                    <td >
                      <div class="row">
                          <div class="col-sm-12 col-sm-12 col-md-6">
                            <div v-html="goal.goaldetails"></div>
                          </div>
                          <div class="col-sm-12 col-sm-12 col-md-6 formatrightdiv">
                            <div v-for="gmap in getmappings">
                              <div v-if="gmap.Year===pyear">
                                <div v-if="goal.gid===gmap.All_goals" style="float: left;">
                                <div v-for="sdg in getsdgs" :key="sdg.sdgsid">
                                    <div v-if="gmap.Sdgs===sdg.sdgsid">
                                      <img :src="`${myPicUrl}${sdg.sdgsimage}`" class="sdgimage"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-3">
        <span v-html="susthighlight" class=" card shadow"  style="padding: 20px;"></span>
      </div>
    </div>
  </div>
</section>

<section style="padding-bottom: 200px;">
  <div class="seven3css" style="max-width: 90%; margin: 0 auto; margin-top: 100px;">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-9">
        <div class="formattoptext"><b>{{pyeardesc}} </b> <b>GOALS AND PERFORNACE</b></div>
        <div class="accordion" id="accordionExample1">
          <div class="accordion-item"  v-for="(cat, index) in getgoalperf" :key="cat.gcid">
            <h2 class="accordion-header" :id="`heading1${cat.gcid}`">
              <button  @click="onClick1(catid=cat.gcid)" class="accordion-button" :id="`accbtn${index%2}`" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse1${cat.gcid}`" aria-expanded="false" :aria-controls="`collapse1${cat.gcid}`">
                {{cat.gcatdesc}}
              </button>
            </h2>
            <div :id="`collapse1${cat.gcid}`" class="accordion-collapse collapse" :aria-labelledby="`heading1${cat.gcid}`" data-bs-parent="#accordionExample1">
              <div class="accordion-body">
                <table class="table">
                  <tr v-for="(goal, index) in allgoalslisting" :key="goal.gid">
                    <td>
                      <div class="row">
                          <div class="col-sm-12 col-sm-12 col-md-6">
                            <div v-html="goal.goaldetails"></div>
                          </div>
                          <div class="col-sm-12 col-sm-12 col-md-6 formatrightdiv">
                            <div v-if="goal.gpefachieved===false">
                              <i class="fa-solid fa-xmark" style="color:red; font-size: 40px;"></i>
                            </div>
                            <div v-else>
                              <i class="fa-solid fa-check" style="color: green; font-size: 40px;"></i>
                            </div>
                          </div>
                        </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-3">
      </div>
    </div>
  </div>
</section>


<div class="allreports">
  <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
  :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
  :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" :bgimage="bgimage" 
  :showbg="showbg"  :showrptfulltext="showrpttext"  />
</div>

    <FooterPage />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import AllReports from '@/components/AllReports.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, AllReports
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  // pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,


 

  getgoalperf: '',
  allgoalslisting: [],
  getmappings: [],
  catid: 0,
  pyear: '',
  pyeardesc: '',
  getsdgs: [],

  susthighlight: '',

  reportpresentation: [],
  lastrecordsreportpresent: [],
  bgimage: '',

  showrpttext: false,
  showbg: false,


  getclickedId: '',
  myPicUrl: '',
  }
},
methods: {
  async onClick(catid) {
    let catidone = catid
  //------------all sliders(generic)---------------
  await axios.get(`getallgoalslistings/${catidone}`).then(
    response => {
        this.allgoalslisting = response.data

        axios.get('getsdgcmappings/goalsandperformance').then(
          response => {
              this.getmappings = response.data
              console.log(this.getmappings)
        })
        .catch((error) => {
            console.log(error)
          })
  })
  .catch((error) => {
      console.log(error)
    })
},
async onClick1(catid) {
    let catidone = catid
  //------------all sliders(generic)---------------
  await axios.get(`getallgoalslistings/${catidone}`).then(
    response => {
        this.allgoalslisting = response.data

        axios.get('getsdgcmappings/goalsandperformance').then(
          response => {
              this.getmappings = response.data
              console.log(this.getmappings)
        })
        .catch((error) => {
            console.log(error)
          })
  })
  .catch((error) => {
      console.log(error)
    })
}
},
async mounted() {
  this.myPicUrl = myUrlPath
await axios.get('allpagespv/goalsandperformance').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvsrc
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
      console.log(error)
    })
   //------------corpgovernance info---------------
   await axios.get('getsustainabilityoverview/').then(
    response => {
        this.sustsec1text = response.data[0].sustsec1text
        // this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------all highlights---------------
  await axios.get('getallhiglights/goalsandperformance').then(
    response => {
        this.susthighlight = response.data[0].highlightdesc
  })
  .catch((error) => {
      console.log(error)
    })

  //------------Get Reports---------------
  await axios.get('reportpresentationlisting/goalsandperformance').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        this.bgimage = response.data.bgimage
        this.showrpttext = response.data.showrptfulltext
        this.showbg = response.data.showbgimage
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })
  

  //------------all sliders(generic)---------------
  await axios.get('getbgimage/goalsandperformance').then(
    response => {
        this.bgimage = response.data[0].bgimageupload
  })
  .catch((error) => {
      console.log(error)
    })

  //------------all sliders(generic)---------------
  await axios.get('getallgoalscategory/').then(
    response => {
        this.getgoalperf = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------YEARS---------------
  await axios.get('getyears/').then(
    response => {
        this.pyear = response.data[0].yearid
        this.pyeardesc = response.data[0].yeardesc
  })
  .catch((error) => {
      console.log(error)
    })

  //------------SDGS---------------
   await axios.get('getsdgslistings/').then(
    response => {
        this.getsdgs = response.data
        console.log(this.getsdgs)
  })
  .catch((error) => {
      console.log(error)
    })

}
}
</script>

<style scoped>
.txtdata {
  text-align: left;
  background-color: #003;;
  margin-left: 0px;
  opacity: 0.7;
  margin-top: -100px;
 }
.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.seven3css {
 max-width: 90%; 
 margin: 0 auto; 
 margin-top: 200px;
}

.reportpresentcss {
  margin-top: 300px;
}

#accordionFlushExample {
  padding-left: 100px;
  width: 90%;
}
.sdgimage {
  width: 114px;
  height: 114px;
  border-radius: 8px;
  padding: 2px;
  margin: 0 auto;
}
table, td, th {
  border: 1px solid;
}
table {
  width: 100%;
  border-collapse: collapse;
  background-color: whitesmoke;
}
.formattoptext {
  padding: 20px; 
  border-top: thin solid orangered; 
  font-size: 30px;
}
.formatrightdiv {
  border-left: solid thin; 
  text-align: center;
}
#accbtn0 {
  background-color:whitesmoke;
}
#accbtn1 {
  background-color:rgb(236, 234, 236);
}
/* Move the background and make it larger. 
/* Media Query CSS*/
.tdcolor0 {
  background-color:rgb(236, 234, 236);
}

/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .txtdata {
    margin-bottom: 200px;
    width: 600px;
    padding-right: 10px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .txtdata {
    margin-bottom: 30px;
    width: 700px;
    padding-right: 10px;
  }
 }


 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .txtdata {
    margin-bottom: 30px;
    width: 800px;
    padding-right: 10px;
  }
 }


 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .txtdata {
    margin-bottom: 100px;
    width: 900px;
    padding-right: 10px;
  }
 } 

/* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {

  }
  
  @media only screen and (min-width: 1600px) {

  } 
</style>
